"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackground = exports.Button = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
const polished_1 = require("polished");
exports.Button = styled_components_1.styled.button `
  ${({ kind, theme }) => (0, exports.getBackground)(kind, theme)};
  box-shadow: ${({ theme }) => theme.boxShadows.highlight},
    ${({ kind, theme }) => kind === "active"
    ? "0 0 0 1px " + theme.highlight
    : theme.boxShadows.low};
  border: none;
  border-radius: ${({ theme }) => theme.radius};
  color: ${({ kind, theme }) => theme.button.color[kind !== null && kind !== void 0 ? kind : "normal"]};
  cursor: pointer;
  padding: 5px 10px;
  margin: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ height }) => (height ? `${height}px` : "30px")};
  min-width: ${({ mini }) => (mini ? 5 : 10)}ex;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  &:hover {
    ${({ kind, theme }) => (0, exports.getBackground)(kind, theme, "light")};
  }
  &:disabled,
  &:disabled:hover {
    color: ${({ kind, theme }) => (0, polished_1.transparentize)(0.6)(theme.button.color[kind || "normal"])};
    ${({ kind, theme }) => (0, exports.getBackground)(kind, theme, "dark")};
    cursor: default;
    svg {
      opacity: 0.3;
    }
  }
  svg {
    fill: ${({ kind, theme }) => {
    if (kind === "active") {
        return theme.highlight;
    }
}};
  }
`;
const getBackground = (kind = "normal", theme, shade, percentage = 0.1) => {
    let colour = theme.button.bg[kind];
    if (shade === "light")
        colour = (0, polished_1.lighten)(percentage)(colour);
    else if (shade === "dark")
        colour = (0, polished_1.darken)(percentage)(colour);
    return getGradient(colour, kind === "active");
};
exports.getBackground = getBackground;
const getGradient = (start, invert) => (0, polished_1.linearGradient)({
    colorStops: [
        `${(0, polished_1.lighten)(0.4)(start)} 0%`,
        `${(0, polished_1.lighten)(0.2)(start)} 2%`,
        `${(0, polished_1.lighten)(0.1)(start)} 8%`,
        `${start}`,
    ],
    toDirection: invert ? "to top" : "to bottom",
    fallback: start,
});
//# sourceMappingURL=Button.js.map